export default __webpack_public_path__ + "static/media/icon_close_20_w.340b65c1.svg";